<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/dzpI6A/tc-custom/9781466847040.jpg?1733030816695" alt="This image is the cover for the book Virtually Human"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Virtually Human
      </h1>
      <p class="bookDescription body article font2">
        <p><b><i>Virtually Human</i> explores what the not-too-distant future will look like when cyberconsciousness—simulation of the human brain via software and computer technology</b><b>—</b><b>allows our consciousness to be present forever.</b><br/><br/>Meet Bina48, the world's most sentient robot, commissioned by Martine Rothblatt and created by Hanson Robotics. Bina48 is a nascent Mindclone of Martine's wife that can engage in conversation, answer questions, and even have spontaneous thoughts that are derived from multimedia data in a Mindfile created by the real Bina. If you're active on Twitter or Facebook, share photos through Instagram, or blogging regularly, you're already on your way to creating a Mindfile—a digital database of your thoughts, memories, feelings, and opinions that is essentially a back-up copy of your mind. Soon, this Mindfile can be made conscious with special software—Mindware—that mimics the way human brains organize information, create emotions and achieve self-awareness. <br/><br/>This may sound like science-fiction A.I. (artificial intelligence), but the nascent technology already exists. Thousands of software engineers across the globe are working to create cyberconsciousness based on human consciousness and the Obama administration recently announced plans to invest in a decade-long Brain Activity Map project. <i>Virtually Human</i> is the only book to examine the ethical issues relating to cyberconsciousness and Rothblatt, with a Ph.D. in medical ethics, is uniquely qualified to lead the dialogue.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Martine Rothblatt, Ray Kurzweil, Ralph Steadman
      </h2>
      
      <p class="authorDescription body article">MARTINE ROTHBLATT, Ph.D., MBA, J.D. is a lawyer, entrepreneur, and medical ethicist. In 1990 she founded and served as Chairman and CEO of Sirius Satellite Radio (now Sirius XM). When her daughter was diagnosed with a rare disease, Martine left Sirius to search for a cure. She founded United Therapeutics in 1996 and has since served as Chairman and CEO. Martine is also a leading legal advocate for human rights and has led the IBA in presenting the UN with a draft treaty on the genome.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harvard University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6fd40b26